import React, { useState, useEffect, useRef } from 'react';
import useApiRequest from './useApiRequest.jsx';
import { domain } from './Domain.jsx';
import { useLoadingContext } from './LoadingContext.jsx';

const FeedbackList = ({ feedbacks, onDelete }) => {
    function formatDate(date) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }
    return (
        <div>
            {feedbacks.length > 0 && feedbacks.map((feedback, index) => (
                <div key={feedback.id} className='item border-bottom pb-2'>
                    <p className='m-0 fw-bold border p-2 mb-2 mt-2 rounded'>Name: {feedback.name} | <span className='text-secondary'>Phone: {feedback.phone}</span> | <span className='text-secondary'>Email: {feedback.email}</span></p>
                    <p className='m-0 fw-bold text-muted'>Experience: {feedback.experience}</p>
                    <p className='m-0 fw-bold text-muted'>Reason: {feedback.reason}</p>
                    <p className='m-0 fs-6 text-muted fs-6'>Message:<br />{feedback.comment}</p>
                    <div className='d-flex gap-2'>
                        <small>{formatDate(new Date(feedback.created_at))}</small>
                        <small>{feedback.address}</small>
                    </div>
                    <div className='d-flex gap-2'>
                        <button onClick={() => onDelete(feedback.id)} className='btn btn-sm mt-2 btn-outline-danger'>Delete</button>
                    </div>
                </div>
            ))}
        </div>
    );
};

const FeedbackComponent = () => {
    const { setLoading } = useLoadingContext()
    const [feedbacks, setFeedbacks] = useState([]);
    const { getRequest, deleteRequest } = useApiRequest();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                await fetchFeedback();
            } catch (error) {
                console.error('Error fetching feedback:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const fetchFeedback = async () => {
        const response = await getRequest(`${domain}/feedback`);
        setFeedbacks(response.body);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this feedback?")) {
            setLoading(true)
            const response = await deleteRequest(`${domain}/feedback/${id}`);
            setFeedbacks(feedbacks.filter((feedback) => feedback.id !== id));
            setLoading(false)
        }
    };

    // Calculate average rating
    const averageRating = feedbacks.length > 0 
        ? (feedbacks.reduce((sum, feedback) => {
            const rating = feedback.experience === 'excellent' ? 5 :
                          feedback.experience === 'verygood' ? 4 :
                          feedback.experience === 'good' ? 3 :
                          feedback.experience === 'average' ? 2 : 1;
            return sum + rating;
        }, 0) / feedbacks.length).toFixed(1)
        : 0;

    return (
        <div className='w-100'>
            {/* Average Rating Display */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-yellow-100 rounded-xl flex items-center justify-center">
                        <svg className="w-5 h-5 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                        </svg>
                    </div>
                    <div>
                        <p className="text-lg font-semibold text-gray-800">
                            Average Rating: <span className="text-yellow-600">{averageRating}/5</span>
                        </p>
                        <p className="text-sm text-gray-600">Based on {feedbacks.length} reviews</p>
                    </div>
                </div>
            </div>

            <FeedbackList
                feedbacks={feedbacks}
                onDelete={handleDelete}
            />
        </div>
    );
};

export default FeedbackComponent;